import { Head, usePage } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminMarketsShow } from '@/types';
import { MarketAdminForm } from './components/MarketAdminForm';
import { MarketLifecycle } from './components/MarketLifecycle';

export default function Show({
  event,
  eventSlug,
  market,
  projects,
  tradeCount,
  title,
}: AdminMarketsShow) {
  // One error line per card, keyed by which mutation failed. Inertia types `errors` as
  // "field -> message or nested bag"; every key this controller sends is a flat string.
  const errors = usePage().props.errors as unknown as Record<
    string,
    string | undefined
  >;

  return (
    <>
      <Head title={title} />
      <div className="container mx-auto flex max-w-3xl flex-col gap-5 py-6">
        <h1 className="font-bold text-2xl">Banana Market — {event.name}</h1>

        <Card className="rounded-none">
          <CardHeader>
            <CardTitle>Configuration</CardTitle>
          </CardHeader>
          <CardContent>
            <MarketAdminForm
              eventSlug={eventSlug}
              market={market}
              error={errors.market}
            />
          </CardContent>
        </Card>

        {market && (
          <Card className="rounded-none">
            <CardHeader>
              <CardTitle>Lifecycle</CardTitle>
            </CardHeader>
            <CardContent>
              <MarketLifecycle
                eventSlug={eventSlug}
                status={market.status}
                winnerProjectId={market.winnerProjectId}
                projects={projects}
                error={errors.lifecycle}
              />
            </CardContent>
          </Card>
        )}

        {market && (
          <Card className="rounded-none">
            <CardHeader>
              <CardTitle>Stats</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col gap-1 text-sm">
              <p>
                Status: <span className="font-mono">{market.status}</span>
              </p>
              <p>
                Trades: <span className="font-mono">{tradeCount}</span>
              </p>
              <p>
                Projects in market:{' '}
                <span className="font-mono">{projects.length}</span>
              </p>
            </CardContent>
          </Card>
        )}
      </div>
    </>
  );
}
